<template>
  <el-input
    :style="inputRootStyle"
    :value="displayText"
    :placeholder="placeholder"
    :autocomplete="autocomplete"
    @input="onInput"
    @keyup.enter.native="onEnterNative"
  />
</template>

<script>
import "@/utils/helpers/formatacao";

export default {
  name: "InputCpfPassaporte",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    borderColor: {
      type: String,
      required: false
    }
  },
  computed: {
    displayText() {
      return this.formatCpfPassaporteDisplay(this.value);
    },
    inputRootStyle() {
      if (!this.borderColor) {
        return null;
      }
      return { "--icp-border-color": this.borderColor };
    }
  },
  methods: {
    formatCpfPassaporteDisplay(raw) {
      const r = raw == null ? "" : String(raw);
      if (!r) {
        return "";
      }
      if (/^\d+$/.test(r)) {
        if (r.length === 11 && r.isCPF()) {
          return r.formatarCpfCnpj();
        }
        return r;
      }
      return r;
    },
    parseCpfPassaporteInput(incoming) {
      const prev = this.value == null ? "" : String(this.value);
      const v = incoming == null ? "" : String(incoming);

      if (v.isCPF()) {
        return v.replace(/\D/g, "").slice(0, 11);
      }

      if (prev.isCPF()) {
        return v.replace(/\./g, "").replace(/-/g, "");
      }

      return v;
    },
    onInput(incoming) {
      this.$emit("input", this.parseCpfPassaporteInput(incoming));
    },
    onEnterNative() {
      this.$emit("enter");
    }
  }
};
</script>

<style scoped>
::v-deep .el-input__inner:focus {
  border-color: var(--icp-border-color);
}
</style>
